import { TextField } from "@mui/material";
import { useResourcesContext } from "app/contexts/resources";
import { useEffect, useState } from "react";

const initialCity = {
  ciudad_id: 0,
  ciudad_matricula_requerida: false,
  ciudad_inscripcion_requerida: true,
  ciudad_tomo_requerido: true,
};

export function RegistroMercantilMatriculaTextField({
  label = "Matrícula",
  value = "",
  onChange = () => {},
  disabled = false,
  ciudadId = 0,
}) {
  const { getCiudad } = useResourcesContext();

  const [ciudad, setCiudad] = useState(initialCity);

  useEffect(() => {
    if (!!ciudadId) {
      const ciudad = getCiudad(ciudadId);

      setCiudad(ciudad);
    }
  }, [ciudadId, getCiudad]);

  return (
    <TextField
      type="text"
      label={`${label} (${
        !!ciudad.ciudad_matricula_requerida ? "requerida" : "opcional"
      })`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      fullWidth
      required={!!ciudad.ciudad_matricula_requerida}
      disabled={disabled}
    />
  );
}
